import LinkViewModelT from '@/ViewModels/Controls/LinkViewModel';
import ToolBarViewModelT from '@/ViewModels/Controls/ToolBarViewModel';
import LinkViewModelBuilder from '@/Builder/LinkViewModelBuilder';
import ControlViewModelBuilder from '@/Builder/ControlViewModelBuilder';
import ComponentManager from '@/Management/ComponentManager';
import {IToolBarViewModelConstructorParameter, ToolBarItemViewModel} from '#/DefaultViewExtensionInterfaces';
import Utilities from '@/Utility/Utilities';
import ToolBarLinkViewModel from '@/Components/Links/ToolBarLinkViewModel';

export default class ToolBarViewModelBuilder<T = null> extends ControlViewModelBuilder<ToolBarViewModelT, T> {

    protected properties: IToolBarViewModelConstructorParameter;
    private primaryLinks: LinkViewModelBuilder<this>[] = [];
    private secondaryLinks: LinkViewModelBuilder<this>[] = [];
    private extendedLinks: LinkViewModelBuilder<this>[] = [];

    public constructor(parent?: T) {
        super(parent);

        this.withLocator('toolbar');
    }

    public withDetectOverflowOnSecondaryItems(detectOverflowOnSecondaryItems: ObservableOrDefault<boolean>): this {
        this.properties.detectOverflowOnSecondaryItems = detectOverflowOnSecondaryItems;

        return this;
    }

    public withPrimaryLink(): LinkViewModelBuilder<this> {
        const builder = new LinkViewModelBuilder<this>(this);
        this.primaryLinks.push(builder);

        return builder;
    }

    public withSecondaryLink(): LinkViewModelBuilder<this> {
        const builder = new LinkViewModelBuilder<this>(this);
        this.secondaryLinks.push(builder);

        return builder;
    }

    public withExtendedLink(): LinkViewModelBuilder<this> {
        const builder = new LinkViewModelBuilder<this>(this);
        this.extendedLinks.push(builder);

        return builder;
    }

    public withPrimaryLinks(links: ToolBarItemViewModel[]) {
        this.properties.primary = links.filter(x => !Utilities.isNullOrUndefined(x));

        return this;
    }

    public withSecondaryLinks(links: ToolBarItemViewModel[]) {
        this.properties.secondary = links.filter(x => !Utilities.isNullOrUndefined(x));

        return this;
    }

    public withExtendedLinks(links: ToolBarItemViewModel[]) {
        this.properties.extended = links.filter(x => !Utilities.isNullOrUndefined(x));

        return this;
    }

    /**
     * @override
     * @inheritdoc 
     */
    protected buildInternal(): ToolBarViewModelT {
        this.buildLinks();
        const ToolBarViewModel = ComponentManager.getViewModel<typeof ToolBarViewModelT>('ToolBarViewModel');
        const toolBar = new ToolBarViewModel(this.properties);

        toolBar.primary().forEach(l => this.addToolBarReference(l, toolBar));
        toolBar.secondary().forEach(l => this.addToolBarReference(l, toolBar));
        toolBar.extended().forEach(l => this.addToolBarReference(l, toolBar));

        return toolBar;
    }

    private buildLinks(): void {
        if (Utilities.isNullOrUndefined(this.properties.primary))
            this.properties.primary = [];

        if (Utilities.isNullOrUndefined(this.properties.secondary))
            this.properties.secondary = [];

        if (Utilities.isNullOrUndefined(this.properties.extended))
            this.properties.extended = [];


        let primaryLinks = ko.unwrap(this.properties.primary);
        let secondaryLinks = ko.unwrap(this.properties.secondary);
        let extendedLinks = ko.unwrap(this.properties.extended);

        primaryLinks.push.apply(primaryLinks, this.primaryLinks.map(x => x.build()));
        secondaryLinks.push.apply(secondaryLinks, this.secondaryLinks.map(x => x.build()));
        extendedLinks.push.apply(extendedLinks, this.extendedLinks.map(x => x.build()));

        ko.isObservable(this.properties.primary) ? this.properties.primary(primaryLinks) : this.properties.primary = primaryLinks;
        ko.isObservable(this.properties.secondary) ? this.properties.secondary(secondaryLinks) : this.properties.secondary = secondaryLinks;
        ko.isObservable(this.properties.extended) ? this.properties.extended(extendedLinks) : this.properties.extended = extendedLinks;
    }

    private addToolBarReference(item: ToolBarItemViewModel, toolBar: ToolBarViewModelT) {
        // ToolBarLinkViewModel erweitert LinkViewModel, deshalb ist eine Kompatibilität mit ToolBarItemViewModel möglich
        if (!(item instanceof ToolBarLinkViewModel)) {
            return;
        }

        if (!Utilities.isNullOrUndefined(item.toolBar)) {
            return;
        }

        item.toolBar = toolBar;
    }
}